import {
    isKeyboardCalendarEventInteractionOpen,
    isKeyboardCalendarEventInteractionDelete,
    isKeyboardCalendarEventInteractionForwardEvent,
    isKeyboardCalendarEventInteractionReplyAll,
    isKeyboardCalendarEventInteractionReply,
} from '../typeGuard';
import { KeyboardCalendarEventInteraction } from '../schema';

const KeyboardInteractionActionIdPairs = [
    { action: isKeyboardCalendarEventInteractionOpen, id: KeyboardCalendarEventInteraction.Open },
    {
        action: isKeyboardCalendarEventInteractionDelete,
        id: KeyboardCalendarEventInteraction.Delete,
    },
    {
        action: isKeyboardCalendarEventInteractionForwardEvent,
        id: KeyboardCalendarEventInteraction.Forward,
    },
    {
        action: isKeyboardCalendarEventInteractionReplyAll,
        id: KeyboardCalendarEventInteraction.ReplyAll,
    },
    { action: isKeyboardCalendarEventInteractionReply, id: KeyboardCalendarEventInteraction.Reply },
];

export function getKeyboardCalendarEventInteraction(
    event: React.KeyboardEvent<HTMLElement>
): KeyboardCalendarEventInteraction | null {
    for (const { action, id } of KeyboardInteractionActionIdPairs) {
        if (action({ event })) {
            return id;
        }
    }

    return null;
}
